import React from "react";
import { Checkbox, Button, Popconfirm } from "antd";
import { injectIntl } from "react-intl";
import { Svg } from "./Svg";
import "./portlet.css";

const Portlet = props => {
  const { formatMessage } = props.intl;
  let className = "portlet portlet-boxed";
  if (props.className) {
    className += " " + props.className;
  }
  return (
    <div className={className} style={props.style}>
      {props.header ? (
        <div className="portlet-header">
          {props.preHeader ? props.preHeader : ""}
          <h2 className="portlet-title">{props.header}</h2>
          {props.list ? (
            <div className="portlet-tools dashboard-buttons">
              <Button className="add" onClick={props.onToggle}>
                <Svg id="add"/>
              </Button>
              <Popconfirm
                placement="leftTop"
                title={formatMessage({
                  id: `popconfirm.title.${props.isProject? 'project': 'offer'}`,
                  defaultMessage: "Are you sure you want to delete selected?"
                })}
                onConfirm={props.onDelete}
                okText={formatMessage({
                  id: "popconfirm.yes",
                  defaultMessage: "Yes"
                })}
                cancelText={formatMessage({
                  id: "popconfirm.no",
                  defaultMessage: "No"
                })}
              >
                <Button className="del" disabled={props.isDisabledDel} >
                  <Svg id="del"/>
                </Button>
              </Popconfirm>
              <Checkbox onClick={props.onCheck} checked={props.checked} />
            </div>
          ) : (
            ""
          )}
          {props.tools ? (
            <div className="portlet-tools">{props.tools}</div>
          ) : (
            ""
          )}
        </div>
      ) : (
        ""
      )}
      <div className="portlet-body">{props.children}</div>
    </div>
  );
};

export default injectIntl(Portlet);



// WEBPACK FOOTER //
// ./src/components/utils/portlet.js